import { jsx as _jsx } from "react/jsx-runtime";
import AppRouter from "@/routes/AppRouter";
var App = function () {
    return _jsx(AppRouter, {});
};
export default App;
